export default class ReadingCollapsable {
    constructor($trigger) {
        this.$trigger = $trigger;
        this.$body = this.$trigger.nextElementSibling;

        this.toggle = this.toggle.bind(this);

        this.$trigger.addEventListener('click', this.toggle);
    }

    toggle(e) {
        e.preventDefault();

        this.$trigger.classList.toggle('collapsable-trigger--active');
        this.$body.classList.toggle('collapsable--expanded');
    }
}